import { render } from "./yearlyStats.vue?vue&type=template&id=34e1e078&scoped=true"
import script from "./yearlyStats.vue?vue&type=script&lang=js"
export * from "./yearlyStats.vue?vue&type=script&lang=js"

import "./yearlyStats.vue?vue&type=style&index=0&id=34e1e078&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e1e078"]])

export default __exports__